import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileSize'
})
export class FileSizePipe implements PipeTransform {

  transform(value: any, unit: 'K'|'M'): any {
    if (typeof value !== 'number'){
      return value;
    }
    let result = 0;
    switch (unit){
      case 'K':
        result = Number((value / 1024).toFixed(2));
        break;
      case 'M':
        result = Number((value / 1024 / 1024).toFixed(2));
        break;
    }
    return result;
  }

}
